<pw-progress-bar></pw-progress-bar>
<div class="delivery-container">
    <div class="delivery-title">
        <h3>{{ "shoppingCart.deliveryOption" | translate }}</h3>
    </div>
    <div class="shipping-wrapper">
        <div class="input">
            <div class="checkbox-container">
                <div class="delivery-radio">
                    <div class="radio">
                        <mat-radio-group
                            aria-labelledby="example-radio-group-label"
                            class="example-radio-group"
                            [(ngModel)]="deliveryOptionElement"
                        >
                            <mat-radio-button
                                (click)="setDeliveryDataInToSession(delivery)"
                                class="example-radio-button"
                                *ngFor="let delivery of deliveryOptionList"
                                [value]="delivery"
                            >
                                <h4>{{"shoppingCart." + delivery.name! | translate }}</h4>
                            </mat-radio-button>
                        </mat-radio-group>
                        <!-- <div class="fees">
                            <div *ngFor="let delivery of deliveryOptionss" class="fee">
                                {{delivery.deliveryFee | currency : 'Ft' : 'symbol' : '1.0-0'}}
                            </div>
                        </div> -->
                    </div>
                    <div *ngIf="deliveryOptionElement.name==='FOXPOST' && separated" class="contact-form">
                        <div [ngStyle]="{'height':'700px'}" class="foxpost">
                            <div class="foxpostFee">
                                <b
                                    >{{ "shoppingCart.foxpostDeliveryFee" | translate }}{{deliveryOptionElement.deliveryFee | currency :
                                    'Ft' : 'symbol' : '1.0-0'}}</b
                                ><br />
                                <span> {{ "shoppingCart.deliveryWithPreorderSeparated" | translate }}</span><br />
                                <span>{{ "shoppingCart.freeDeliveryFeeSeparated" | translate }}</span><br />
                                <span>{{ "shoppingCart.payWithCard" | translate }}</span><br />
                            </div>
                            <div
                                [ngStyle]="{'display':'flex','width':'100%','align-items':'center','flex-direction':'column','margin-top':'8px'}"
                            >
                                <span>Válassza ki az Önhöz legközelebb eső FOXPOST automatát!</span><br />
                                <button (click)="this.loadSelectedMaterial(this.enterAnimationDuration,this.exitAnimationDuration)">
                                    FOXPOST kiválasztása
                                </button>
                                <div class="foxpost-address" *ngIf="data.deliveryOption == 'FOXPOST' && data.deliveryZipCode!=null">
                                    <span>Kiválasztott csomagpont: {{this.data.deliveryAddress}}</span><br />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="deliveryOptionElement.name==='FOXPOST' && !separated" class="contact-form">
                        <div [ngStyle]="{'height':'520px'}" class="foxpost">
                            <div class="foxpostFee">
                                <b
                                    >{{ "shoppingCart.foxpostDeliveryFee" | translate }}{{deliveryOptionElement.deliveryFee | currency :
                                    'Ft' : 'symbol' : '1.0-0'}}</b
                                ><br />
                                <span>{{ "shoppingCart.freeDeliveryFee" | translate }}</span><br />
                                <span>{{ "shoppingCart.payWithCard" | translate }}</span><br />
                            </div>
                            <div
                                [ngStyle]="{'display':'flex','width':'100%','align-items':'center','flex-direction':'column','margin-top':'8px'}"
                            >
                                <span>Válassza ki az Önhöz legközelebb eső FOXPOST automatát!</span><br />
                                <button (click)="this.loadSelectedMaterial(this.enterAnimationDuration,this.exitAnimationDuration)">
                                    FOXPOST kiválasztása
                                </button>
                                <div class="foxpost-address" *ngIf="data.deliveryOption == 'FOXPOST' && data.deliveryZipCode!=null">
                                    <span>Kiválasztott csomagpont: {{this.data.deliveryAddress}}</span><br />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="deliveryOptionElement.name==='MPL' && separated" class="mpl-container">
                        <div class="mpl-datas">
                            <div class="mplFee">
                                <span [ngStyle]="{'font-weight':'bold'}"
                                    >{{ "shoppingCart.mplDeliveryFee" | translate }}{{deliveryOptionElement.deliveryFee | currency : 'Ft' :
                                    'symbol' : '1.0-0'}}</span
                                ><br />
                                <span [ngStyle]="{'font-weight':'bold'}"
                                    >Kezelési költség: {{deliveryOptionElement.handlingFee | currency : 'Ft' : 'symbol' : '1.0-0'}}</span
                                ><br />
                                <span [ngStyle]="{'font-weight':'bold'}"
                                    >Összesen: {{(deliveryOptionElement.deliveryFee!+deliveryOptionElement.handlingFee!) | currency : 'Ft' :
                                    'symbol' : '1.0-0' }}</span
                                ><br />
                                <span> {{ "shoppingCart.mplSeparatedText" | translate }} </span><br /><br />
                                <span>{{ "shoppingCart.payWithCard" | translate }}</span><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="deliveryOptionElement.name==='MPL' && !separated" class="mpl-container">
                        <div [ngStyle]="{'height':'100px'}" class="mpl-datas">
                            <div [ngStyle]="{'font-weight':'bold'}" class="mplFee">
                                <span
                                    >{{ "shoppingCart.mplDeliveryFee" | translate }}{{deliveryOptionElement.deliveryFee | currency : 'Ft' :
                                    'symbol' : '1.0-0'}}</span
                                ><br />
                                <span>Kezelési költség: {{deliveryOptionElement.handlingFee | currency : 'Ft' : 'symbol' : '1.0-0'}}</span
                                ><br />
                                <span
                                    >Összesen: {{(deliveryOptionElement.deliveryFee!+deliveryOptionElement.handlingFee!) | currency : 'Ft' :
                                    'symbol' : '1.0-0' }}</span
                                ><br />
                                <span>{{ "shoppingCart.payWithCard" | translate }}</span><br />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="deliveryOptionElement.name==='PACKETA'" class="packeta-container">
                        <div class="packeta">
                            <!-- <ul>
                                <li><p>{{"shoppingCart.getPacketInterval" | translate}}</p></li>
                                <li><p>{{"shoppingCart.packetaPaymentOption" | translate}}</p></li>
                                <li><p>{{"shoppingCart.packetaPoints" | translate}}</p></li>
                            </ul> -->
                            <div class="choose-packeta">
                                <p>{{ "shoppingCart.chooseDeliveryPlace" | translate }}</p>
                                <button
                                    class="packeta-selector-open"
                                    (click)="Packeta.Widget.pick(packetaApiKey, showSelectedPickupPoint, packetaOptions)"
                                >
                                    Csomagpont kiválasztása
                                </button>
                            </div>
                            <div class="packeta-address" *ngIf="data.deliveryOption == 'PACKETA'">
                                <p>Kiválasztott csomagpont: {{this.data.deliveryAddress}}</p>
                            </div>
                            <!-- <div *ngIf="data.deliveryOption != 'PACKETA'"><p class="packeta-selector-value"></p></div> -->
                        </div>
                    </div>
                    <div *ngIf="deliveryOptionElement.name==='STORE_PICKUP'" class="personal-receiving">
                        <div class="personal-infos">
                            <b>{{ "shoppingCart.freeStorePickupText" | translate | uppercase }}</b><br />
                            <span>{{ "shoppingCart.companyName" | translate }}<b>{{ "shoppingCart.address" | translate }}</b></span
                            ><br />
                            <span
                                >Elérhetőség: {{ "shoppingCart.phoneNumber" | translate }}, {{ "shoppingCart.emailAddress" | translate
                                }}</span
                            ><br />
                            <span [ngStyle]="{'color':'red', 'font-weight':'bold'}"
                                >{{ "shoppingCart.openingHoursText" | translate | uppercase }}<b
                                    >{{ "shoppingCart.openingDays" | translate }}</b
                                ></span
                            ><br />
                            <span>{{ "shoppingCart.paymentOptions" | translate }}</span><br />
                            <span>{{ "shoppingCart.storeOrderTill" | translate }}</span><br />
                            <span>{{ "shoppingCart.preorderPaymentOption" | translate }}</span><br />
                            <span></span><br />
                            <span></span><br />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-container">
            <div class="buttons">
                <button routerLink="/contact">{{ "shoppingCart.backToPersonalDatas" | translate }}</button>
                <button (click)="goToPay()" type="submit">{{ "shoppingCart.goToPayFromCart" | translate }}</button>
            </div>
        </div>
    </div>
</div>
